// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10ZM3","left":"styles_left__3dckm"};